export default __webpack_public_path__ + "static/media/google-gmail-logo-small.cdc0d3ae.svg";